import createReducer from 'store/createReducer';
import type { Action, Nullable } from 'store/model';

import {
  BillingReducer,
  PAYMENT_REQUEST,
  PAYMENT_SUCCESS,
  PAYMENT_FAILURE,
  ActionPayment,
} from './types';






const initialState: BillingReducer = {
  items: [],
  loading: false,
  error: null,
  success: false,
  response: null,
};

export const billingReducer = createReducer<BillingReducer>(initialState, {
  [PAYMENT_REQUEST]: (state: Nullable<BillingReducer>, action: any) => ({
    ...state,
    items: action.payload,
    loading: true,
    error: null,
    success: false,
    response: null
  }),

  [PAYMENT_SUCCESS]: (state: Nullable<BillingReducer>, action: Action<Nullable<ActionPayment>>) => ({
    ...state,
    loading: false,
    error: null,
    success: true,
    response: action.payload
  }),

  [PAYMENT_FAILURE]: (state: Nullable<BillingReducer>, action: Action<Nullable<ActionPayment>>) => ({
    ...state,
    loading: false,
    error: action.payload,
    success: false
  })
})
